import PropTypes from 'prop-types';

import { IconDirection, IconOrientation, IconSize } from 'constants/coreDesignSystem';

export const rotationEnum = {
  [IconDirection.UP]: 'rotate-180',
  [IconDirection.DOWN]: 'rotate-0',
  [IconDirection.LEFT]: 'rotate-90',
  [IconDirection.RIGHT]: '-rotate-90',
};

export const orientationEnum = {
  [IconOrientation.HORIZONTAL]: 'rotate-0',
  [IconOrientation.ANGLE]: 'rotate-45',
  [IconOrientation.VERTICAL]: 'rotate-90',
};

export const sizePropsTypes = {
  size: PropTypes.number,
};

export const defaultSize = IconSize[24];
